import { render, staticRenderFns } from "./BusinessContact.vue?vue&type=template&id=2622c6e1&"
import script from "./BusinessContact.vue?vue&type=script&lang=js&"
export * from "./BusinessContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VDivider,VThemeProvider})
